<template>
  <section
    v-if="breadcrumb"
    class="el-section"
  >
    <nav class="emd-breadcrumb">
      <ol>
        <li
          v-if="breadcrumb.refer"
          class="emd-breadcrumb__item"
        >
          <app-breadcrumb-item :name="breadcrumb.refer" />
        </li>
        <li
          v-if="breadcrumb.parents"
          class="emd-breadcrumb__item"
        >
          <app-breadcrumb-link :items="breadcrumb.parents" />
        </li>
        <li
          v-if="breadcrumb.current"
          class="emd-breadcrumb__item _active"
        >
          <app-breadcrumb-item :name="breadcrumb.current" />
        </li>
      </ol>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'AppBreadcrumbNew',

  components: {
    AppBreadcrumbItem: () => import('./AppBreadcumbItem.vue'),
    AppBreadcrumbLink: () => import('./AppBreadcrumbLink.vue')
  },

  data () {
    return {
      breadcrumb: []
    }
  },

  mounted () {
    this.updateList()
  },

  watch: {
    $route () {
      this.updateList()
    }
  },

  methods: {
    updateList () {
      this.breadcrumb = this.$route.meta.breadcrumb
    }
  }
}
</script>
